import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import ThemeCustomization from 'themes';

import 'assets/scss/style.scss';
import { Grid, Typography } from '@material-ui/core';

import Login from './Login';
import Signup from './Signup';
import google from '../../assets/Google-Play-Logo-PNG.png';
import apple from '../../assets/Apple-AppStore-logo.png';

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

class LoginSignupV2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login: true,
      forgotPassword: false,
      confirmResetPassword: false,
      user_type: 'brand',
      passwordOk: true,
      showDomainInvalid: false,
      uid: '',
      token: '',
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem('access') &&
      JSON.parse(localStorage.getItem('user')).user_type === 'brand'
    ) {
      this.props.history.push('/planner/discover');
    } else if (
      localStorage.getItem('access') &&
      JSON.parse(localStorage.getItem('user')).user_type === 'influencer'
    ) {
      this.props.history.push('/influencer');
    }

    const queryParams = qs.parse(this.props.location.search.replace('?', ''));
    if (queryParams.t === 'brand-signup') {
      this.setState({
        login: false,
      });
    }
    if (queryParams.t === 'brand-login') {
      this.setState({
        login: true,
      });
    }
    const url_attr = this.props.location.pathname.split('/');
    console.log(url_attr);
    if (url_attr[2] !== 'undefined') {
      if (url_attr[1] === 'signup') {
        this.setState({
          login: false,
        });
      }
      if (url_attr[1] === 'login') {
        this.setState({
          login: true,
        });
      }
      if (url_attr[1] === 'forgot-password') {
        this.setState({
          forgotPassword: true,
        });
      }
      if (url_attr[1] === 'password-reset-confirm') {
        this.setState({
          confirmResetPassword: true,
          uid: url_attr[2],
          token: url_attr[3],
        });
      }
    }
  }

  toggleLogin = () => {
    if (this.state.login) {
      this.props.history.push('/signup');
    } else {
      this.props.history.push('/login');
    }
  };

  render() {
    return (
      <ThemeCustomization>
        {this.state.confirmResetPassword ? (
          <ResetPassword
            goToLogin={() => {
              this.props.history.push('/login');
            }}
            uid={this.state.uid}
            token={this.state.token}
          />
        ) : this.state.forgotPassword ? (
          <ForgotPassword
            goToLogin={() => {
              this.props.history.push('/login');
            }}
          />
        ) : this.state.login ? (
          <Login
            showDomainInvalidModal={() => {
              this.setState({ showDomainInvalid: true });
            }}
            toggleLogin={this.toggleLogin}
            goToForgotPassword={() => {
              this.props.history.push('/forgot-password');
            }}
            goToDiscover={() => {
              localStorage.removeItem('popUpAppearance');
              localStorage.setItem('extension', parseInt(1));
              this.props.history.push('/planner/discover');
            }}
            goToCreatorApp={() => {
              this.props.history.push('/influencer');
            }}
          />
        ) : (
          <Signup
            showDomainInvalidModal={() => {
              this.setState({ showDomainInvalid: true });
            }}
            toggleLogin={this.toggleLogin}
            goToDiscover={() => {
              localStorage.removeItem('popUpAppearance');
              localStorage.setItem('extension', parseInt(1));
              this.props.history.push('/planner/discover');
            }}
          />
        )}
        {this.state.showDomainInvalid ? (
          <React.Fragment>
            <BootstrapDialog
              onClose={() => {
                this.setState({ showDomainInvalid: false });
              }}
              aria-labelledby="customized-dialog-title"
              open={true}
              fullWidth
            >
              <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title"></DialogTitle>
              <IconButton
                aria-label="close"
                onClick={() => {
                  this.setState({ showDomainInvalid: false });
                }}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
              <DialogContent dividers>
                <Grid container alignItems="center">
                  <Grid item>
                    <Typography style={{ fontSize: '13px' }}>
                      <span style={{ fontWeight: '600' }}>
                        Oops! It looks like there's an issue with your email domain
                      </span>
                      . Our dashboard is designed for brands only. If you're an influencer, you can{' '}
                      <span style={{ fontWeight: '600' }}>sign up on our mobile app</span> instead.
                    </Typography>
                  </Grid>
                  <Grid item style={{ marginTop: '7px', width: '100%' }}>
                    <Grid container alignItems="center" justifyContent="center">
                      <Grid
                        item
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          window.open(
                            'https://play.google.com/store/apps/details?id=in.influencer',
                            '_blank',
                          );
                        }}
                      >
                        <img alt="" src={google} style={{ width: '120px', height: '40px' }}></img>
                      </Grid>

                      <Grid
                        item
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                        onClick={() => {
                          window.open(
                            'https://apps.apple.com/in/app/influencer-in/id1640001193',
                            '_blank',
                          );
                        }}
                      >
                        <img alt="" src={apple} style={{ width: '120px' }}></img>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Typography style={{ fontSize: '13px' }}>
                      For any assistance, feel free to reach out at{' '}
                      <a href="Enquiry@influencer.in">Enquiry@influencer.in</a>, and we'll be happy
                      to help!{' '}
                    </Typography>
                  </Grid>
                </Grid>
              </DialogContent>
            </BootstrapDialog>
          </React.Fragment>
        ) : null}
      </ThemeCustomization>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(LoginSignupV2);
